<template>
    <div class="main"
        :data-component-name="$options.name"
    >
        <div>
            <router-view :email="email"  :reset_token="reset_token"></router-view>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        email: {
            type: String,
            default: null
        },
        reset_token: {
            type: String,
            default: null
        },
    },
}
</script>

<style lang="scss" scoped>
    @import "@/scss/global.scss";
</style>
